import { ICopyFuncionarioUseCase } from "../../../presentation/useCases/create/copy_funcionario_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CopyFuncionarioUseCase
 */

export class CopyFuncionarioUseCase implements ICopyFuncionarioUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async copyFuncionario(
    idFuncionario: number,
    idCentroCusto: number,
    idCargo: number,
    dataAdmissao: Date,
  ): Promise<void> {
    await this.repository.copyFuncionario(
      idFuncionario,
      idCentroCusto,
      idCargo,
      dataAdmissao,
    );
  }
}
